angular.module('mercury.modules.qa.menumate.discountlines')
.controller('QaMenumateDiscountLinesReportCtrl', ["$filter", "$http", "reporttime", "$scope", "title", "settings", function($filter, $http, reporttime, $scope, title, settings) {
  title.set('Discount Lines Report');

  $scope.loading = $http.get(settings.apiHost + '/r/PosQaMenumateDiscountLines', {
    params: {
      startTime: reporttime.start(),
      endTime: reporttime.end()
    }
  });

  $scope.loading.then(function(response) {
    title.setSubheader(response.data.notes);
    $scope.terminalGroups = [];
    angular.forEach($filter('groupby')(response.data.lines, 'terminalName'), function(group) {
      $scope.terminalGroups.push($filter('groupby')(group, 'timeStampBilled'));
    });

    $scope.allLines = response.data.lines;
  });
}]);
